import { SyntheticEvent, useState } from 'react'
import {
  TextInput,
  useLogin,
  useNotify,
  Form,
  required,
  // email,
  minLength,
  useAuthState,
  useTranslate,
  useRedirect,
} from 'react-admin'
import { Link as RouterLink } from 'react-router-dom'
import { Link, Stack, IconButton, InputAdornment } from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import { LoadingButton } from '@mui/lab'
import config from '../../../config'

const validateUsername = [/* email(), */ required()]
// TODO: Pending switch back to minimum length of 6 characters
// const validatePassword = [required(), minLength(6)]
const validatePassword = [required(), minLength(4)]

const LoginForm = (): JSX.Element => {
  const translate = useTranslate()
  const ptForgotPasswordLink = config('ptForgotPasswordLink')
  const [showPassword, setShowPassword] = useState(false)
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const { isLoading } = useAuthState()
  const login = useLogin()
  const notify = useNotify()
  const redirect = useRedirect()

  const handleSubmit = (): void => {
    login({ username, password })
      .then((res) => {
        if (!res?.message) {
          redirect('/')
          return
        }
        notify(res?.message)
      })
      .catch((e) => {
        notify(e.message)
      })
  }

  const handleShowPassword = (): void => {
    setShowPassword((show) => !show)
  }
  return (
    <Form noValidate onSubmit={handleSubmit}>
      <Stack spacing={3}>
        <TextInput
          fullWidth
          autoComplete='username'
          type='text'
          label={translate('ra.auth.username')}
          validate={validateUsername}
          onChange={(e: SyntheticEvent): void => setUsername((e.target as HTMLInputElement).value)}
          source='username'
        />
        <TextInput
          fullWidth
          autoComplete='current-password'
          type={showPassword ? 'text' : 'password'}
          label={translate('ra.auth.password')}
          InputProps={{
            endAdornment: (
              <InputAdornment position='end'>
                <IconButton onClick={handleShowPassword} edge='end'>
                  {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          validate={validatePassword}
          onChange={(e: SyntheticEvent): void => setPassword((e.target as HTMLInputElement).value)}
          source='password'
        />
      </Stack>

      <LoadingButton fullWidth size='large' variant='contained' type='submit' loading={isLoading}>
        {translate('ra.auth.sign_in')}
      </LoadingButton>

      <Stack direction='row' alignItems='center' justifyContent='space-between' sx={{ my: 2 }}>
        <Link
          component={RouterLink}
          variant='subtitle2'
          to={ptForgotPasswordLink}
          underline='hover'
          target='_blank' // Open link in a new tab
          rel='noopener noreferrer'
        >
          {translate('ra.auth.forgot_password')}
        </Link>
      </Stack>
    </Form>
  )
}

export default LoginForm
